import React, { useState } from 'react';
import { X } from 'lucide-react';
import './AddUserModal.css';

const AddUserModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
        role: 'Team Member',
        reportsTo: '',
        status: 'active'
    });

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Adding user:', formData);
        onClose();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h4>Add New User</h4>
                    <button className="close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>
                <form onSubmit={handleSubmit} className="add-user-form">
                    <div className="modal-scroll-content">
                        <div className="form-group">
                            <label>Full Name</label>
                            <input
                                type="text"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                placeholder="Enter full name"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="e.g. name@company.com"
                                required
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Phone Number</label>
                                <input
                                    type="tel"
                                    name="phoneNumber"
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    placeholder="Enter phone number"
                                />
                            </div>

                            <div className="form-group">
                                <label>Role</label>
                                <select name="role" value={formData.role} onChange={handleChange}>
                                    <option value="Team Lead">Team Lead</option>
                                    <option value="Manager">Manager</option>
                                    <option value="Team Member">Team Member</option>
                                </select>

                            </div>
                        </div>

                        <div className="form-row">
                            {formData.role === 'Team Member' ? (
                                <div className="form-group animate-slide-down">
                                    <label>Reports To</label>
                                    <select name="reportsTo" value={formData.reportsTo} onChange={handleChange}>
                                        <option value="">Select Team Lead</option>
                                        <option value="Sarah Chen">Sarah Chen</option>
                                        <option value="Jacob Shahjan">Jacob Shahjan</option>
                                    </select>
                                </div>
                            ) : (
                                <div className="form-group spacer"></div>
                            )}

                            <div className="form-group status-toggle-container">
                                <label>Status</label>
                                <div className="toggle-wrapper" onClick={() => setFormData(prev => ({ ...prev, status: prev.status === 'active' ? 'inactive' : 'active' }))}>
                                    <div className={`toggle-switch ${formData.status === 'active' ? 'active' : ''}`}>
                                        <div className="toggle-handle"></div>
                                    </div>
                                    <span className="status-label">{formData.status.charAt(0).toUpperCase() + formData.status.slice(1)}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="cancel-btn" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="submit-btn invite">
                            Create & Invite
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddUserModal;
